import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {
    CmContractNavigationBaseComponentComponent
} from "../cm-contract-navigation-base-component/cm-contract-navigation-base-component.component";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";


@Component({
    selector: 'cm-contract-coverages-navigation',
    templateUrl: './cm-contract-coverages-navigation.component.html',
    standalone: false
})
export class CmContractCoveragesNavigationComponent extends CmContractNavigationBaseComponentComponent implements OnInit, OnChanges, OnDestroy {

    coveragesWidget: WidgetData;

    constructor(protected override coreService: MvsCoreService) {
        super(coreService);
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets() {
        const alias = "cm.contract.coverages.navigation.new" + this.aliasSuffix;
        const filter = [FilterCriteria.create('e.contractId', FilterCriteria.cOperatorEqual, this.contractDto.id)];

        this.coveragesWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            alias,
            'Deckungen',
            'ci.ContractCoverage',
            filter
        );

        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'contractDtoId', fieldValue: this.contractDto.id}];
        this.coveragesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }

        if (changes["contractDto"]) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
